export const TriggerIcon = () => {
  return (
    <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
      <mask
        height="24"
        id="mask0_10934_8658"
        maskUnits="userSpaceOnUse"
        style={{ maskType: 'alpha' }}
        width="24"
        x="0"
        y="0"
      >
        <rect fill="#D9D9D9" height="24" width="24" />
      </mask>
      <g mask="url(#mask0_10934_8658)">
        <path
          d="M9.31592 19.7032V17.7167L6.63717 15.038C6.43276 14.8336 6.2755 14.5981 6.1654 14.3316C6.05513 14.0652 6 13.7856 6 13.4928V9.0694C6 8.46036 6.21448 7.94039 6.64345 7.50949C7.07242 7.07859 7.59142 6.86314 8.20046 6.86314H9.11571L8.01548 7.95756V4.10023C8.01548 3.79152 8.12163 3.53093 8.33394 3.31846C8.54641 3.10615 8.807 3 9.11571 3C9.42441 3 9.68492 3.10615 9.89723 3.31846C10.1097 3.53093 10.2159 3.79152 10.2159 4.10023V6.86894H13.7841V4.10023C13.7841 3.79152 13.8903 3.53093 14.1028 3.31846C14.3151 3.10615 14.5756 3 14.8843 3C15.193 3 15.4536 3.10615 15.6661 3.31846C15.8784 3.53093 15.9845 3.79152 15.9845 4.10023V7.95756L14.8843 6.86314H15.7995C16.4086 6.86314 16.9276 7.07859 17.3565 7.50949C17.7855 7.94039 18 8.46036 18 9.0694V13.4928C18 13.7856 17.9449 14.0652 17.8346 14.3316C17.7245 14.5981 17.5672 14.8336 17.3628 15.038L14.6841 17.7167V19.7032C14.6841 20.0119 14.5779 20.2725 14.3656 20.4849C14.1531 20.6973 13.8926 20.8034 13.5838 20.8034H10.4162C10.1074 20.8034 9.84685 20.6973 9.63439 20.4849C9.42208 20.2725 9.31592 20.0119 9.31592 19.7032Z"
          fill="#0056B8"
        />
      </g>
    </svg>
  );
};
